import Vue from 'vue'
import Melon from '@guazi-fe/melon'
import '@guazi-fe/melon/lib/index.less'
import 'imc-mobile/src/component/style/main.less' // 引入imc-mobile样式
import './style/main.less'
import * as util from 'imc-mobile/src/util/index'
import 'lib-flexible'

import CarheaderBar from 'imc-mobile/src/component/headerBar'
import CarTable from 'imc-mobile/src/component/table'
import CarRadioGroup from 'imc-mobile/src/component/dynamicForm/components/Items/Field/RadioGroup/index'
import CarCheckBoxGroup from 'imc-mobile/src/component/dynamicForm/components/Items/Field/CheckBoxGroup/index'
import CarRate from 'imc-mobile/src/component/dynamicForm/components/Items/Field/Rate/index'
import CarNps from 'imc-mobile/src/component/dynamicForm/components/Items/Field/Nps/index'
import CarMatrixRate from 'imc-mobile/src/component/dynamicForm/components/Items/Field/MatrixRate'
import CarCalendar from 'imc-mobile/src/component/dynamicForm/components/Items/Field/Calendar'
import CarPicker from 'imc-mobile/src/component/dynamicForm/components/Items/Field/Picker'
import SearchInput from 'imc-mobile/packages/search-input'
import SearchOption from 'imc-mobile/packages/search-option'
import store from './store'
import router from './router'
import App from './App'

Vue.use(Melon)

Vue.use(CarheaderBar)
// Vue.use(CarDynamicForm)
Vue.use(CarTable)
Vue.use(CarRadioGroup)
Vue.use(CarRate)
Vue.use(CarNps)
Vue.use(CarMatrixRate)
Vue.use(CarCheckBoxGroup)
Vue.use(CarCalendar)
Vue.use(CarPicker)
Vue.use(SearchInput)
Vue.use(SearchOption)
// Vue.use(Loading)

Vue.config.devtools = true
Vue.prototype.$jump = util.default.jump
Vue.config.productionTip = false

window.$CA = {
    util: util.default,
}

// if (process.env.NODE_ENV !== 'development') {
// const VConsole = require('vconsole')
// eslint-disable-next-line
// new VConsole()
// }
Vue.config.productionTip = process.env.NODE_ENV !== 'development'

if (process.env.NODE_ENV == 'development') {
    Vue.config.warnHandler = function (msg, vm, trace) {
        if (msg.includes('Invalid prop: type check failed for prop "value"')) return
        console.warn('[Vue warn]:', msg, trace)
    }
}

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
